import { Period } from "@components/period"
import { Stack, Group, Text, PaperProps } from "@mantine/core"
import { v4 } from "uuid"
import { CalendarAppointmentPaper } from "./CalendarAppointmentPaper"
import { CalendarAppointmentType } from "./CalendarAppointmentType"
import { useRenderCastTime } from "../renderCastTime"

interface Props extends PaperProps {
  appointment: CalendarAppointmentType
}

export function CalendarAppointment({ appointment, ...props }: Props) {
  const { renderCastTime } = useRenderCastTime()

  return (
    <CalendarAppointmentPaper key={v4()} appointment={appointment} {...props}>
      <Stack gap={0}>
        <Group
          wrap="nowrap"
          justify={
            appointment.start === null && appointment.end === null
              ? "center"
              : undefined
          }
        >
          {appointment.start || appointment.end ? (
            <Period w={85} start={appointment.start} end={appointment.end} />
          ) : null}
          {appointment?.source === "Cast" ||
          appointment?.source === "PossibleCast" ? (
            <Text span>{appointment?.source === "PossibleCast" && "?"}</Text>
          ) : null}
          <Stack gap={0}>
            <Text span>
              {appointment.type && <Text span>{appointment.type}</Text>}
              <Text
                span
                style={{
                  ...(appointment.isPublicEvent
                    ? { fontWeight: 500 }
                    : undefined),
                }}
              >
                {appointment.title}
              </Text>
              {appointment.location && (
                <Text span>{` (${appointment.location})`}</Text>
              )}
              {appointment.status && (
                <Text span>{` (${appointment.status})`}</Text>
              )}
            </Text>
            {appointment.description && (
              <Text
                c={
                  appointment.foreColorHEX === null
                    ? undefined
                    : appointment.foreColorHEX
                }
              >
                {appointment.description}
              </Text>
            )}
          </Stack>
        </Group>
        {appointment.additionalCastTimes?.map((t) => (
          <Text key={v4()}>{renderCastTime(t)}</Text>
        ))}
      </Stack>
    </CalendarAppointmentPaper>
  )
}
